import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_CONFIG } from '../config/api.config';

@Injectable({ providedIn: 'root' })
export class FilesService {
    private http = inject(HttpClient);

    downloadPrivateFile(fileId: string): Observable<Blob> {
        const id = encodeURIComponent(String(fileId || '').trim());
        if (!id) throw new Error('Missing fileId');
        return this.http.get(`${API_CONFIG.FILES_URL}/private/${id}`, { responseType: 'blob' });
    }
}

